import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { fetchRecentWins } from "../api/enterpriseClient";

export const recentWinsQueryOptions = (customerId: number) =>
  queryOptions({
    queryKey: ["enterprise-recent-wins", customerId],
    queryFn: () => fetchRecentWins(customerId),
    staleTime: 5 * 60_000,
  });

export function useGetRecentWins(customerId: number) {
  return useSuspenseQuery(recentWinsQueryOptions(customerId));
}
